import { SearchExistingField } from '@skyline-platform/alchemy';
import { getContacts } from '@utils/graphql/creators/contacts';
import PropTypes from 'prop-types';
import { ContactForm } from '@components/FormComponents/ContactForm/ContactForm';
import { useState } from 'react';
import { getLogger } from '@utils/general';
import { getContactLabelAndName } from '@pages/utils/helpers';

const logger = getLogger('src.components.FormComponents.ContactForm.SearchExistingContact');

export const SearchExistingContact = ({ ...props }) => {
  const { formData, setFormData } = { ...props };
  const [newCreatedContact, setNewCreatedContact] = useState(() => formData || {});

  const getAvailableContacts = async () => {
    const { query, execute } = getContacts();
    query.addReturnProperties('firstName', 'lastName', 'id', 'emailAddress');

    try {
      let res = await execute();
      const normalizedData = res.data.map((contact) => {
        return {
          ...contact,
          name: getContactLabelAndName(contact).label,
        };
      });

      return {
        ...res,
        data: normalizedData,
      };
    } catch (error) {
      logger.error(error.message);
    }
  };

  return (
    <SearchExistingField
      fieldName='Contact'
      required
      fetchData={getAvailableContacts}
      newlyCreatedItem={newCreatedContact}
      newFieldForm={(handleClose) => (
        <ContactForm
          handleClose={handleClose}
          setNewCreatedContact={setNewCreatedContact}
          setFormData={setFormData}
        />
      )}
      {...props}
    />
  );
};

SearchExistingContact.propTypes = {
  formData: PropTypes.shape({
    contact: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
};
